import React from 'react';
import { blindBuriedHole } from 'shared/data/selectOptions';
import { blindBuriedHole as blindBuriedHoleTooltip } from 'shared/data/tooltips';
import CheckboxComponent from 'shared/components/CheckboxComponent';

const BlindBuriedHole = (props) => {
  const name = 'blind_buried_hole';
  const { label, tooltip, parameters, onChangeParameter } = props;

  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label={label}
      tooltip={tooltip}
      checked={parameters[name] === '1'}
      onChange={(e) => onChangeParameter(name, e.target.checked ? '1' : '0')} />
  );
};

BlindBuriedHole.defaultProps = {
  options: blindBuriedHole,
  label: 'Blind and Buried Hole',
  tooltip: blindBuriedHoleTooltip,
};

export default BlindBuriedHole;
